import { getEnv, types } from 'mobx-state-tree'
import { ApiRest } from 'ogram-react'

import { DataStore } from './data-store/data-store'
import { Enviroment } from './environment/environment'

export const PaginatorModel = types.model('Paginator', {
  current_page: types.number,
  next_page: types.maybeNull(types.number),
  per_page: types.number,
  last_page: types.number,
  total: types.number,
})

export const commonViews = (self: DataStore) => ({
  get apiHost() {
    return (getEnv<Enviroment>(self).api as ApiRest).api.defaults.baseURL as string
  },
})
